<template>
  <div class="ex-release">
    <div class="title">免费发布需求</div>
    <div class="p-box">
      <div class="p-box_select">
        <span class="label" style="margin-left: 0">供需类型</span>
        <Select
          v-model="typeId"
          style="width: 200px; height: 42px; margin-left: 20px; margin-top: 6px"
        >
          <Option v-for="item in typeList" :value="item.id" :key="item.name">{{
            item.name
          }}</Option>
        </Select>
      </div>
      <div class="p-box_select">
        <span class="label">我需要</span>
        <Input
          type="text"
          placeholder="如 N95口罩生产线推荐"
          style="width: 200px; height: 42px; margin-left: 20px; margin-top: 6px"
          v-model="info"
        />
      </div>
      <div class="p-box_select">
        <span class="label">联系人</span>
        <Input
          type="text"
          placeholder="如 请输入您的称谓"
          style="width: 200px; height: 42px; margin-left: 20px; margin-top: 6px"
          v-model="name"
        />
      </div>
      <div class="p-box_select">
        <span class="label">手机号</span>
        <Input
          type="text"
          placeholder="信息保护中，仅官方可见"
          style="width: 200px; height: 42px; margin-left: 20px; margin-top: 6px"
          v-model="phone"
        />
      </div>
      <!-- <div class="p-box_item" :class="rule.info===1? 'active':''">
        <div class="label">我需要</div>
        <input type="text" placeholder="如 N95口罩生产线推荐" v-model="info" />
      </div>
      <div class="p-box_item" :class="rule.name===1? 'active':''">
        <div class="label">联系人</div>
        <input type="text" placeholder="请输入您的称谓" v-model="name" />
      </div>
      <div class="p-box_item" :class="rule.phone===1? 'active':''">
        <div class="label">手机号</div>
        <input type="text" placeholder="信息保护中，仅官方可见" v-model="phone" />
      </div> -->
      <div class="btn" @click="submit()">发布需求</div>
    </div>
    <div class="brand-box">
      <Row :gutter="20">
        <Col span="8">
          <div class="brand-item">
            <img src="@assets/img/icon-speed.png" />极速匹配
          </div>
        </Col>
        <Col span="8">
          <div class="brand-item">
            <img src="@assets/img/icon-save.png" />平台担保
          </div>
        </Col>
        <Col span="8">
          <div class="brand-item">
            <img src="@assets/img/icon-pei.png" />先行赔付
          </div>
        </Col>
      </Row>
    </div>
    <div class="news-list">
      <!-- <div class="news-l">
        <span>最新</span>
      </div> -->
      <div class="news-r" v-if="newChanceList.length">
        <swiper :options="swiperOption">
          <swiperSlide
            v-for="(card, index) in newChanceList"
            :key="'card' + index"
          >
            <div
              class="swiper-li"
              v-for="(c, index) in card"
              :key="'c' + index"
            >
              <div class="news-l">
                <span>最新</span>
              </div>
              <p>{{ c.information }}</p>
              <span>{{ $service.SmarDate(new Date(c.inTime)) }}</span>
            </div>
          </swiperSlide>
        </swiper>
      </div>
      <div class="no-msg" v-else>暂无数据！</div>
    </div>

    <!-- 发布需求成功提示 -->
    <!-- <Modal v-model="modal" width="538" :footer-hide="true" :class-name="'my-modal ex-release'">
      <div class="demand-modal-content">
        <p>已收到您发布的需求</p>
        <p>我们会尽快联系您，请保持手机畅通，谢谢！</p>
        <Button style="height:40px;font-size:16px;" type="error" @click="modal=false;">关闭</Button>
      </div>
    </Modal> -->
    <gLogin :show="show" @close="show = false" />
  </div>
</template>

<script>
import gLogin from "@components/gLogin/gLogin.vue";
import { mapActions, mapGetters } from "vuex";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "ex-release",
  props: {
    // exhibitionInfo: {
    //   type: Object,
    //   default: null
    // },
    newChanceList: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      typeId: "",
      typeList: [],
      info: "",
      name: "",
      phone: "",
      rule: {
        info: 0,
        name: 0,
        phone: 0,
      },
      modal: false,
      swiperOption: {
        autoplay: true,
        direction: "vertical",
        loop: true,
        height: 100,
      },
      show: false,
    };
  },
  components: {
    swiper,
    swiperSlide,
    gLogin,
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      exhibition: "loginModule/getExhibition",
    }),
  },
  methods: {
    ...mapActions({
      sendRelease: "hall/sendRelease",
      getRelease: "hall/getRelease",
    }),
    formValid() {
      if (this.info === "") {
        this.rule.info = 1;
      } else {
        this.rule.info = 0;
      }
      if (this.name === "") {
        this.rule.name = 1;
      } else {
        this.rule.name = 0;
      }
      if (this.phone === "" || /^[1][0-9]{10}$/.test(this.phone) === false) {
        this.rule.phone = 1;
      } else {
        this.rule.phone = 0;
      }
      if (
        this.rule.info === 1 ||
        this.rule.name === 1 ||
        this.rule.phone === 1
      ) {
        return false;
      } else {
        return true;
      }
    },
    async submit(value) {
      if (!this.user) {
        this.$Message.warning("请登录后发布");
        this.show = true;
        return;
      }
      if (!this.typeId) {
        this.$Message.warning("请选择供需类型");
        return;
      }
      if (this.info === "") {
        this.$Message.warning("请输入需求内容");
        return;
      }
      if (this.name === "") {
        this.$Message.warning("请输入联系人");
        return;
      }
      if (this.phone === "") {
        this.$Message.warning("请输入手机号");
        return;
      } else if (/^[1][0-9]{10}$/.test(this.phone) === false) {
        this.$Message.warning("请输入正确的手机号");
        return;
      }
      // const valid = this.formValid();
      // if (!valid) return;
      var req = {
        AgentId: this.exhibition.agentId,
        ExhibitionId: this.exhibition.id,
        TypeId: this.typeId,
        FromType: 1, // 《0：企业，1：用户》(小程序端只有用户)
        FromId: this.user.userId,
        Information: this.info,
        Subtitle: this.name, // 联系人
        Phone: this.phone,
      };
      var result = await this.sendRelease(req);
      if (result.successed) {
        this.$Message.success("发布成功！");
        this.typeId = "";
        this.info = "";
        this.name = "";
        this.phone = "";
        this.modal = true;
        this.$emit("finish");
      } else {
        this.loading = false;
        if (result.errors && result.errors[0]) {
          this.$Message.error(result.errors[0].description);
          return;
        } else {
          this.$Message.error("发布失败，请重试");
        }
      }
    },
    async init() {
      let typeList = await this.getRelease(this.exhibition.id);

      if (this.user && this.user.userType == 1) {
        this.typeList = typeList;
      } else {
        typeList.forEach((c) => {
          if (c.name != "供应产品") {
            this.typeList.push(c);
          }
        });

        console.log(this.typeList, "typeList");
      }
    },
  },
  created() {
    this.init();
  },
};
</script>

<style scoped lang="scss">
.ex-release {
  display: inline-block;
  width: 376px;
  height: 566px;
  background-color: #fff;
  border: solid 1px #f2eded;
  border: solid 1px #f2eded;
  .title {
    line-height: 48px;
    font-size: 18px;
    padding-left: 20px;
    color: #333;
    font-family: MicrosoftYaHei-Bold;
    border-bottom: 2px solid #c5161b;
    font-weight: bold;
  }
  .p-box {
    &_select {
      padding: 14px 27px 0 40px;
      .label {
        display: inline-block;
        margin-left: 14px;
      }
      // /deep/ .ivu-select-selection {
      //   height: 40px;
      // }
      // /deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder {
      //   line-height: 40px;
      // }
      // /deep/ .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
      //   line-height: 40px;
      // }
    }
    &_item {
      position: relative;
      width: 320px;
      margin-left: auto;
      margin-right: auto;
      background-color: #f2f2f2;
      line-height: 40px;
      border-radius: 4px;
      margin-bottom: 20px;
      padding: 0 14px;
      transition: all 0.5s;
      border: 1px solid #fff;
      input {
        outline: none;
        border: none;
        background: #f2f2f2;
        width: 200px;
        margin-left: 20px;
        line-height: 30px;
        height: 30px;
        font-size: 14px;
      }
      .label {
        display: inline-block;
        font-size: 14px;
        color: #333;
        // margin-right: 14px;
      }
    }
    .btn {
      width: 320px;
      height: 40px;
      line-height: 40px;
      background-color: #ff5f50\9; /* For IE8+ */
      background-image: linear-gradient(-90deg, #ff4062 0%, #ff7c3c 100%),
        linear-gradient(#f2f2f2, #f2f2f2);
      background-blend-mode: normal, normal;
      border-radius: 4px;
      font-size: 14px;
      color: #fff;
      text-align: center;
      margin-bottom: 14px;
      margin: 30px auto 0;
      cursor: pointer;
    }
  }
  .brand-box {
    width: 320px;
    margin: 0 auto;
    text-align: center;
    padding-top: 30px;
    padding-bottom: 20px;
    .brand-item {
      height: 23px;
      line-height: 23px;
      display: inline-block;
      position: relative;
      padding-left: 25px;
      font-size: 12px;
      color: #666;
      img {
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }
  .active {
    border: 1px solid red;
  }
}
.demand-modal-content {
  padding: 70px 90px 50px 90px;
  p {
    font-size: 16px;
    color: #333;
    text-align: center;
  }
  button {
    width: 180px;
    height: 32px;
    margin-top: 60px;
    margin-left: 73px;
    background-color: #db2a4b;
  }
}
.news-list {
  border-top: 1px solid #efefee;
  display: flex;
  margin: 0 15px;
  .news-r {
    width: 100%;
    overflow: hidden;
    height: 100px;
    margin-top: 13px;
    .swiper-li {
      display: flex;
      justify-content: space-between;
      line-height: 33px;
      font-size: 12px;
      color: #4d4d4d;
      p {
        width: 65%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      span {
        width: 30%;
        text-align: right;
      }
      .news-l {
        padding: 0 6px 0 10px;
        span {
          display: inline-block;
          width: 40px;
          height: 20px;
          border-radius: 4px;
          border: solid 1px #0190fe;
          font-size: 12px;
          color: #0190fe;
          line-height: 20px;
          text-align: center;
        }
      }
    }
  }
}
.no-msg {
  font-size: 14px;
  color: #666;
  text-align: center;
  margin-top: 50px;
  width: 100%;
}
</style>
<style lang="scss">
.ivu-message {
  z-index: 1050 !important;
}
</style>